/**
 * The general Clu chat this tab is streaming a turn in. The chat store does
 * not survive a reload, so after one (a deploy's stale-chunk reload included)
 * the chat reopens from here and reattaches through `turn_running`. Storage
 * can throw (blocked or private modes): every read and write is guarded.
 */
const TAB_RUNNING_TURN_KEY = 'cleanlist:clu-running-turn';

export function rememberTabRunningTurn(conversationId: string): void {
  try {
    sessionStorage.setItem(TAB_RUNNING_TURN_KEY, conversationId);
  } catch {
    // A reload then opens a blank chat, as before.
  }
}

/** Forgets the chat, unless another one has taken its place since. */
export function forgetTabRunningTurn(conversationId: string): void {
  try {
    if (sessionStorage.getItem(TAB_RUNNING_TURN_KEY) === conversationId)
      sessionStorage.removeItem(TAB_RUNNING_TURN_KEY);
  } catch {
    // Nothing to forget.
  }
}

/** The chat left streaming before a reload, read once. */
export function takeTabRunningTurn(): string | null {
  try {
    const conversationId = sessionStorage.getItem(TAB_RUNNING_TURN_KEY);
    sessionStorage.removeItem(TAB_RUNNING_TURN_KEY);
    return conversationId || null;
  } catch {
    return null;
  }
}
